import React from "react";
import { Transition } from "react-transition-group";
import classNames from "classnames";
import spinnerImage from "../../images/spinner.svg";

interface Props {
  isActive: boolean;
  hasBackground?: boolean;
}

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1, zIndex: 999, visibility: "visible" },
  exiting: { opacity: 0 },
  exited: { opacity: 0, zIndex: -1, visibility: "none" },
} as { [key: string]: object };

const Spinner: React.FC<Props> = ({
  isActive = false,
  hasBackground = false,
}) => (
  <Transition in={isActive} timeout={duration}>
    {(state) => (
      <div
        className={classNames({
          spinner: true,
          "spinner--with-background": hasBackground,
        })}
        style={{
          ...defaultStyle,
          ...transitionStyles[state],
        }}
      >
        <img
          src={spinnerImage}
          className="spinner__image"
          alt="Spinner figure"
        />
      </div>
    )}
  </Transition>
);

export default Spinner;
